import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getAllAzureResources = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/publish?tenantName=${latestTenant}&type=VIRTUAL_MACHINE&subsId=${subId}`;

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data
};
export const getAllAzureStorage = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/publish?tenantName=${latestTenant}&type=STORAGE_ACCOUNT&subsId=${subId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};
export const getAllAzureDatabase = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/publish?tenantName=${latestTenant}&type=DATABASE&subsId=${subId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};


export const getAllAzureClusters = async (latestTenant: string, subId: string) => {
    let url = `${NGROK}/api/azureResources/v1/publish?tenantName=${latestTenant}&type=AZURE_KUBERNETES&subsId=${subId}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchAzureUserConfig = async (latestTenant: string, email: string) => {
    let url = `${NGROK}/api/azureUserConfigure/v1/get?tenantName=${latestTenant}&email=${email}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const getAzureAllRoles = async (resourceId: string, userId: string, selectedResourceType: string) => {
    let url = `${NGROK}/api/azureResources/v1/applicableRoles?resourceId=${resourceId}&assignee=${userId}`;
    if (selectedResourceType === "vm") {
        url += `&type=VIRTUAL_MACHINE `
    } else if (selectedResourceType === "kubernetes") {
        url += `&type=AZURE_KUBERNETES `
    } else if (selectedResourceType === "database") {
        url += `&type=DATABASE `
    } else if (selectedResourceType === "storage") {
        url += `&type=STORAGE_ACCOUNT`
    }
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};


export const azureSubmitForm = async (payload: any) => {
    let url = `${NGROK}/api/azureResources/v1/requests/raise`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });

    return data;
};

export const fetchAllPublishedTypes = async () => {
    try {
        let url = `${NGROK}/api/k8-resources/v1/publish/types`
        const data = await apiClient({
            method: "GET",
            url: url,
        });
        return data;
    } catch (e) { }
};
export const fetchK8Resources = async (latestTenant: string, clusterId: string, type: string, cloudprovider: string) => {
    let url = `${NGROK}/api/k8-resources/v1/publish?type=${type}&tenantName=${latestTenant}&cloudType=${cloudprovider.toUpperCase()}&clusterId=${clusterId}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
};

export const getK8Roles = async (name: string, payload: any) => {
    let url = `${NGROK}/api/k8-resources/v1/suggestRoles/${name}`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });

    return data;
};

export const submitK8Form = async (payload: any) => {
    let url = `${NGROK}/api/k8-resources/v1/requests/raise`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });

    return data;
};


export const configureUser = async (payload: any) => {
    let url = `${NGROK}/api/azureUserConfigure/v1/create`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });

    return data;
};


export const specificAzureUser = async (latestTenant: string, id: string, subId: string) => {
    let url = `${NGROK}/api/azure/v1/users/getRolesAndGroups?tenantName=${latestTenant}&azureId=${id}`;
    if (subId) {
        url += `&subsId=${subId}`;
    }

    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
};
